// G2 renders /<brand>/users/… as that brand's workspace (ue RoutingFilter::WorkspaceBrand).

export type G2BrandSlug = 'capterra' | 'getapp' | 'softwareadvice';

const WORKSPACE_PATTERN = /^\/(?:users\/(?!auth\/)|assistant(?:\/|$))/;

export function withG2BrandSegment(url: string, slug: G2BrandSlug): string {
  try {
    const parsed = new URL(url);
    const pathname = parsed.pathname;

    // Check if already branded
    if (pathname.startsWith(`/${slug}/`)) {
      return url;
    }

    // Check if it matches workspace pattern
    if (!WORKSPACE_PATTERN.test(pathname)) {
      return url;
    }

    // Insert brand segment
    const newPathname = `/${slug}${pathname}`;
    parsed.pathname = newPathname;

    return parsed.toString();
  } catch {
    // If URL parsing fails, return unchanged
    return url;
  }
}
